'use client';

import { Editor as PrimeEditor, EditorTextChangeEvent } from 'primereact/editor';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { useMemo } from 'react';

export interface IEditor {
  label?: string;
  placeholder?: string;
  id?: string;
  name?: string;
  value?: string | { htmlValue: string; textValue: string; [key: string]: any };
  onChange?: (value: { htmlValue: string; textValue: string; delta: any; source: string }) => void;
}

const Editor = (props: IEditor) => {
  const { label, placeholder, id, name, value, onChange } = props;

  // Convert any non-string value to string to prevent rendering issues
  const safeValue = useMemo(() => {
    if (typeof value === 'object' && value !== null) {
      // If it's already an object with htmlValue, use that
      if ('htmlValue' in value) {
        return value.htmlValue;
      }
      // Otherwise convert the object to an empty string to avoid rendering issues
      return '';
    }
    // If it's a string or undefined, use it as is
    return value || '';
  }, [value]);

  const handleChange = (e: EditorTextChangeEvent) => {
    if (!onChange) return;
    
    const htmlValue = e.htmlValue || '';
    // Create a structured response with both HTML and text values
    const textValue = e.textValue || '';
    
    // Send a properly structured object to the onChange handler
    onChange({
      htmlValue,
      textValue,
      delta: null, // Not using delta in this implementation
      source: 'api'
    });
  };

  return (
    <div className='flex flex-col'>
      {label && (
        <div className='mb-[6px] flex gap-1'>
          <div className='text-primary font-medium text-sm'>{label}</div>
        </div>
      )}
      <PrimeEditor
        id={id}
        placeholder={placeholder}
        value={safeValue as string}
        onTextChange={handleChange}
        style={{ height: '200px' }}
      />
    </div>
  );
};

export default Editor;
